// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKENS: "karli_auth_tokens",
} as const;

// Notification IDs
export const NOTIFICATION_IDS = {
  AUTOLAUNCH: "karli-autolaunch-notification",
  ACTION_PERFORMANCE: "ActionPerformanceNotification",
} as const;

// Icon names
export const ICONS = {
  SMALL: "Icon.16x16",
  LARGE: "Icon.80x80",
} as const;

// Environment defaults
export const DEFAULT_ENVIRONMENT = "local";
